import { memo, type ReactNode, useCallback } from 'react';

import { Button } from '@air/primitive-button';

export type CreditUsageUpsellAlertProps = {
  title: ReactNode;
  description: ReactNode;
  ctaButton?: {
    text: string;
    onClick: () => void;
  };
  dismissButton?: {
    text?: string;
  };
  onDismiss: () => void;
};

export const CreditUsageUpsellAlert = memo(
  ({ title, description, ctaButton, dismissButton, onDismiss }: CreditUsageUpsellAlertProps) => {
    const handleCtaClick = useCallback(() => {
      ctaButton?.onClick();
      onDismiss();
    }, [ctaButton, onDismiss]);

    return (
      <div className="w-80 rounded-8 bg-gray-1">
        <div className="flex flex-col gap-2 p-4">
          <p className="font-semibold text-18 text-gray-12">{title}</p>
          <p className="text-14 text-gray-11">{description}</p>
        </div>
        <div className="flex justify-end gap-2 border-gray-4 border-t p-3">
          <Button
            type="button"
            color={!ctaButton ? 'blue' : 'grey'}
            appearance={!ctaButton ? 'filled' : 'ghost'}
            size="medium"
            onClick={onDismiss}
          >
            {dismissButton?.text ?? 'Dismiss'}
          </Button>
          {!!ctaButton && (
            <Button type="button" color="blue" appearance="filled" size="medium" onClick={handleCtaClick}>
              {ctaButton.text}
            </Button>
          )}
        </div>
      </div>
    );
  },
);

CreditUsageUpsellAlert.displayName = 'CreditUsageUpsellAlert';
